import * as React from 'react'
import styled from 'styled-components'
import type { PolymorphicProps } from 'lib/types/polymorphicProps'

const Root = styled.div`
  @media print {
    display: none;
  }
  &:empty {
    display: none;
  }
`

type Props = {
  children?: React.ReactNode
}

function NoPrint<AsTarget extends React.ElementType = 'div'>(props: PolymorphicProps<Props, AsTarget>) {
  const {
    children,
    ...restProps
  } = props

  return <Root {...restProps}>{children}</Root>
}

export default NoPrint
